import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core'
import { AuthService, RestServices, SharedServices } from '../../../../services'
import { ActivatedRoute, Router } from '@angular/router'
import { DatePipe, DecimalPipe } from '@angular/common'
import { base64toBlob, baseUrlGMO, saveBlob } from '../../../../../helper'
import * as moment from 'moment'
import { User } from '../../../../../models'
import { Subscription } from 'rxjs'

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['../../../../stagingcss/main-body.component.css', './payment.component.css', '../../../../stagingcss/lui-select.component.css'],
})
export class PaymentComponent implements OnInit, AfterViewInit, OnDestroy {
    data: any = {}
    user: User = null
    numClient
    timeNow
    paymentHistories: Array<any> = []
    startDateRegister
    startDateRegisterNext
    en: any = {}
    showEN = true
    isOnPageMode: boolean
    is_free_now: boolean
    link_type_action: string
    langSubscription: Subscription

    constructor(public authData: AuthService, private router: Router, private route: ActivatedRoute,
                private restApi: RestServices, private _sharedService: SharedServices,
    ) {
        this.authData.authToken()
    }

    ngOnInit() {
        this.createMemberLinkType()
        const datePipe = new DatePipe('en-US')
        this.timeNow = datePipe.transform(Date.now(), 'yyyy/MM')
        this.listHistoryCard()
        this.user = this.authData.getUser()

        this.numClient = this.user.numClient
        this.is_free_now = this.user.is_free
        const isSuccess = this.route.snapshot.queryParamMap.get('success')
        if (isSuccess) {
            //update payment attribute on localStorage
            this.user.gmoCardFlg = 1
            this.authData.setUser(this.user)
            window.history.replaceState({}, '', '/app/main/setting/payment')
        }

        this.langSubscription = this._sharedService.language$.subscribe((lang) => {
            if (lang) this.createMemberLinkType();
          });
    }

    /**
     * Redirect linktype GMO
     * Create, edit Member
     * Create, delete Card
     */
    createMemberLinkType() {
        const resourceUrl = 'payment/link-type-info'
        const userMember = this.authData.getUser()
        const lang = this.authData.getPaymentLang();
        const data = {
            ...userMember,
            lang: lang,
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, data, tokenReNew).subscribe((response: any) => {
                if (response) {
                    this.data = {
                        SiteID: response.SiteID,
                        MemberID: userMember._id,
                        MemberName: userMember.name,
                        ShopID: response.ShopID,
                        MemberPassString: response.MemberPassString,
                        RetURL: baseUrlGMO,
                        DateTime: response.DateTime,
                        ClientField3: location.href,
                    }
                    this.link_type_action = response.LinkUrl
                }
            })
        })
    }

    /**
     * list history credit
     */
    listHistoryCard() {
        const resourceUrl = 'payment/history'
        const userMember = this.authData.getUser()._id
        const resourceData = {
            'memberID': userMember,
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.paymentHistories = success['listHistory']
                if (this.paymentHistories) {
                    this.paymentHistories.map(item => item.is_free_payment = this.checkIsFree(item.status))
                }
                this.startDateRegister = this.convertDateObjectID(userMember)
                this.startDateRegisterNext = moment(this.startDateRegister).add(1, 'month').startOf('month')
            })
        })
    }

    /**
     * convert date
     */
    convertDateObjectID(_id) {
        const dateString = _id.toString().substring(0, 8)
        // const date = new Date( parseInt( timestamp, 16 ) * 1000 );

        var year = dateString.substring(0, 4)
        var month = dateString.substring(4, 6)
        var day = dateString.substring(6, 8)

        return year + '/' + month + '/' + day
    }

    convertDateObjectID2(_id) {
        const timestamp = _id.toString().substring(0, 8)
        const date = new Date(parseInt(timestamp, 16) * 1000)
        return date
    }

    getTotalAmount(numClient) {
        let total = 0
        if (numClient > 1000) {
            total = 41000
        } else if (numClient > 200) {
            total = 27000
        } else if (numClient > 50) {
            total = 17000
        } else if (numClient >= 4) {
            total = 11000
        }
        return total
    }

    validToken(token, callback) {
        const resourceUrl = 'payment/valid-token'
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, { token: token }, tokenReNew).subscribe(result => {
                callback(result['success'])
            })
        })
    }

    validCard() {
        const resourceUrl = 'payment/valid-card'

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, null, tokenReNew).subscribe(result => {
                if (result['success']) {

                } else {

                }
            })
        })
    }

    showModalMemberID() {
        this._sharedService.emitChange('activeModalMemberID')
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    getHistoryStatus(status) {
        if (this.en.payment.statues[status]) return this.en.payment.statues[status]
        return this.en.payment.unnecessary
    }

    checkIsFree(status: any) {
        return status && status.indexOf('FREE') == 0
    }

    downloadInvoice(history: any, type: number) {
        const printMode = 1
        const resourceUrl = 'payment/invoice'
        const lang = this.authData.getLang()
        const decimalPipe = new DecimalPipe('en')
        const datePipe = new DatePipe('en')
        const data = {
            contentType: printMode,
            lang: lang,
            type: type,
            yearMonth: history.yearMonth,
            usageFee: history.usageFee,
            numClient: decimalPipe.transform(history.numClient, '1.0'),
            amount: decimalPipe.transform(history.usageFee, '1.0'),
            settlementDate: datePipe.transform(history.createDate, 'yyyy/MM/dd'),
            _id: history._id,
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, data, tokenReNew).subscribe(result => {
                if (result['success']) {
                    if (printMode) {
                        this.printHtml(result['content'])
                    } else {
                        const pdfBlob = base64toBlob(result['content'], 'application/pdf')
                        saveBlob(pdfBlob, type ? 'receipt.pdf' : 'invoice.pdf')
                    }
                }
            })
        })
    }

    printHtml(content) {
        if (this.isOnPageMode) {
            var iframe = document.createElement('iframe')
            document.body.classList.add('print-mode')

            iframe.classList.add('print-zone')
            // iframe.style.opacity = '0';
            document.body.appendChild(iframe)
            var iframedoc = iframe.contentDocument || iframe.contentWindow.document
            iframedoc.body.innerHTML = content
            setTimeout(() => {
                iframe.contentWindow.print()
            }, 100)
        } else {
            const myWindow = window.open()
            myWindow.document.write(content)
            myWindow.document.close()
            myWindow.focus()
            myWindow.print()
        }
    }

    ngOnDestroy(): void {
        this.langSubscription.unsubscribe();
        if (this.isOnPageMode) {
            document.body.classList.remove('print-mode')
            var prints = document.getElementsByClassName('print-zone')
            for (var i = 0; i < prints.length; i++) {
                prints[i].remove()
            }
        }
    }

    ngAfterViewInit(): void {
        this.isOnPageMode = !navigator.userAgent.toLowerCase().includes('firefox')
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/setting/payment/payment.component.ts